import mpa from '@mpfe/mpa';
import { topRoutes } from '@mpfe/cskit';
import { getRoutes } from './dataProvider';
const app = mpa({ silence: true });
export const topRoutesModel = topRoutes({ dataProvider: getRoutes });
app.useModel(topRoutesModel);
app.run();
export default app;
